import { StyleSheet } from '@react-pdf/renderer';
import { RegisterFont } from '../RegisterFont';

RegisterFont();

export const headerStyle = StyleSheet.create({
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    info: {
        flexDirection: 'column',
        rowGap: 4,
    },
    organizationName: {
        textTransform: 'uppercase',
        color: '#4B99F5',
        fontSize: 12,
        fontWeight: 500,
        fontFamily: 'Roboto',
    },
    project: {
        fontSize: 16,
        color: '#22262F',
        fontWeight: 500,
        fontFamily: 'Roboto',
    },
    period: {
        fontSize: 12,
        fontFamily: 'Roboto',
        color: '#455166',
    },
    image: {
        width: 150,
        height: 30,
    },
    unofficialTimeSheet: {
        textAlign: 'center',
        color: 'red',
        fontSize: 14,
        marginBottom: 10,
    },
});
